import { Component } from '@angular/core';
import { LanguageService } from 'src/app/core/language.service';

@Component({
  selector: 'app-lang-switch',
  templateUrl: './lang-switch.component.html',
  styleUrls: ['./lang-switch.component.css']
})
export class LangSwitchComponent {
  constructor(public lang: LanguageService) {}
}
